var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Topo'),_c('notifications'),_c('side-bar',{staticClass:"d-print-none scrollMenu"},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
        name: 'Página Inicial',
        icon: 'fas fa-home text-light',
        path: '/home'
      }}}),(_vm.perfilColaborador || _vm.perfilCoordenador || _vm.perfilDiretor || _vm.perfilAdmin)?_c('sidebar-item',{attrs:{"id":"menuOkr","link":{
        name: 'OKR',
        icon: 'fas fa-bullseye text-light',
      }}},[_c('sidebar-item',{attrs:{"id":"menuOkrCadastro","link":{ name: 'Cadastro',      path: '/okr-cadastro' }}}),_c('sidebar-item',{attrs:{"id":"menuOkrMonitoramento","link":{ name: 'Monitoramento', path: '/okr' }}})],1):_vm._e(),(_vm.perfilColaborador || _vm.perfilCoordenador || _vm.perfilDiretor || _vm.perfilAdmin)?_c('sidebar-item',{attrs:{"id":"projetos","link":{
        name: 'Projetos',
        icon: 'far fa-calendar-check text-light',
      }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Cadastro', path: '/projeto-cadastro' }}}),_c('sidebar-item',{attrs:{"id":"menuProjeto","link":{ name: 'Listagem', path: '/projeto-listagem' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Validação', path: '/projeto-validacao' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Pendente', path: '/projeto-pendente' }}})],1):_vm._e(),(_vm.perfilColaborador || _vm.perfilCoordenador || _vm.perfilDiretor || _vm.perfilAdmin)?_c('sidebar-item',{attrs:{"id":"menuAtividade","link":{
        name: 'Atividades',
        icon: 'fas fa-calendar-check text-light',
       }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Cadastro', path: '/atividade-cadastro' }}}),_c('sidebar-item',{attrs:{"id":"atividade","link":{ name: 'Listagem', path: '/atividade-listagem' }}})],1):_vm._e(),(_vm.perfilAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Usuários',
        icon: 'fas fa-users text-light',
        path: '/lead'
      }}}):_vm._e(),(_vm.perfilAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Estrutura',
        icon: 'fas fa-boxes text-light',
        path: '/estrutura'
      }}}):_vm._e(),(_vm.perfilAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Tipo Atividade',
        icon: 'fas fa-clipboard-list text-light',
        path: '/tipo-atividade'
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Kanban',
          icon: 'fas fa-paper-plane text-light',
          path: '/kanban'
        }}}),_c('sidebar-item',{attrs:{"link":{
        name: 'Meus Dados',
        icon: 'ni ni-credit-card text-light',
        path: '/meuperfil/meusdados'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: 'Mensagem',
        icon: 'fas fa-envelope text-light',
        path: '/mensagem'
      }}}),(_vm.perfilAdmin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Logs',
        icon: 'fa fa-history text-light',
        path: '/log'
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{ name: 'Sair', path: '/sair', icon: 'ni ni-button-power text-light' }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }